// ** Dropdowns Imports
import { Fragment, useEffect, useState } from 'react'
import NotificationDropdown from './NotificationDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
// ** Third Party Components
import { IconHelp } from '@tabler/icons-react'
import { IconSun, IconMoon, IconMenu2 } from '@tabler/icons-react'
import styled from 'styled-components'
import { NavItem, NavLink, UncontrolledTooltip } from 'reactstrap'
import { Button, Drawer } from 'dsm-react-lib'
import { modifyTopbarStyle } from '../../../../utility/Utils'
import { useSelector } from 'react-redux'
import SupportForm from '../../../../views/Support/SupportForm'

export const Container = styled.div`
  display: flex;
  float: right;
`
export const Icon = styled.img`
  cursor: pointer;
`

const OptionsList = styled.ul`
  align-items: center;
  gap: 1.3rem;
  margin-right: -1rem;
  margin-left: 0.7rem;
`

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props
  const [openSidebar, setOpenSidebar] = useState(false)
  const layoutStore = useSelector((state) => state.layoutReducer)
  const menuCollapsed = layoutStore.menuCollapsed

  useEffect(() => {
    modifyTopbarStyle(openSidebar, menuCollapsed)
  }, [openSidebar])

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <IconSun className="ficon" onClick={() => setSkin('light')} />
    }

    return <IconMoon className="ficon" onClick={() => setSkin('dark')} />
  }

  return (
    <Fragment>
      <ul className="navbar-nav d-xl-none d-flex align-items-center">
        <NavItem className="mobile-menu me-auto">
          <NavLink
            className="nav-menu-main menu-toggle hidden-xs is-active"
            onClick={() => setMenuVisibility(true)}>
            <IconMenu2 className="ficon" />
          </NavLink>
        </NavItem>
      </ul>
      <div className="bookmark-wrapper d-flex align-items-center">
        <NavbarSearch />
      </div>
      <div className="ms-auto d-flex">
        <OptionsList className="nav navbar-nav align-items-center">
          {/* removed for v1
          <NavItem className="d-none d-lg-block">
            
            <NavLink className="nav-link-style">
              <ThemeToggler />
            </NavLink> 
          </NavItem>*/}
          <NotificationDropdown />
          <UncontrolledTooltip target={'bell'}>{'Notification centre'}</UncontrolledTooltip>
          <Button
            label="Need help?"
            onClick={() => setOpenSidebar(!openSidebar)}
            color="info"
            icon={<IconHelp size={20} />}
            data-testid="needHelpBtn"
          />
          <UserDropdown />
        </OptionsList>
      </div>
      <Drawer
        className="theme-drawer support-drawer"
        header={
          <div className="flex items-center justify-between w-full pr-2">
            <h4 className="subsection-header mb-0 p-1">Support</h4>
          </div>
        }
        hasCloseButton={true}
        isOpen={openSidebar}
        setIsOpen={() => setOpenSidebar(false)}
        closeOnOutsideClick={true}
        overlay={true}>
        {openSidebar && <SupportForm />}
      </Drawer>
    </Fragment>
  )
}
export default NavbarUser
